import React, { useCallback, useState } from "react";
import classNames from "classnames";
import Modal from "@/ui/Modal/Modal";
import Button from "@/ui/Button/Button";
import { CheckIcon, ChevronIcon } from "@/assets/icons";
import { useStatisticsTariffStore } from "@/store/statisticsTariffStore";
import { useUserInfoStore } from "@/store/userInfoStore";
import cls from "./styles.module.scss";

const pluralTariffs = (n: number) => {
  const a = n % 10;
  const b = n % 100;
  if (a === 1 && b !== 11) return "тариф";
  if (a >= 2 && a <= 4 && (b < 12 || b > 14)) return "тарифа";
  return "тарифов";
};

const getTariffsLabel = (selected: string[] | null) => {
  if (!selected) return "Все тарифы";
  if (selected.length === 1) return selected[0];
  return `${selected.length} ${pluralTariffs(selected.length)}`;
};

export const TariffSelector = () => {
  const { serviceType } = useUserInfoStore.getState();
  const isServiceType = serviceType || "delivery";
  const tariffs = {
    eats: ["Еда Пеший", "Еда Авто"],
    delivery: [
      "Грузовой",
      "Авто",
      "Мото",
      "Пеший",
      "Еда Пеший",
      "Еда Авто",
      "Такси",
    ],
    taxi: ["Такси", "Грузовой", "Авто", "Мото", "Пеший"],
  };

  const selectedTariffs = useStatisticsTariffStore((s) => s.selectedTariffs);
  const setSelectedTariffs = useStatisticsTariffStore(
    (s) => s.setSelectedTariffs
  );

  const [isOpen, setIsOpen] = useState(false);
  // выбор внутри шторки применяется только кнопкой, тап по фону — отмена
  const [draft, setDraft] = useState<string[] | null>(null);

  const isAllSelected = draft === null;
  const isNoneSelected = !!draft && draft.length === 0;

  const openSheet = () => {
    setDraft(selectedTariffs ? [...selectedTariffs] : null);
    setIsOpen(true);
  };

  const closeSheet = useCallback(() => setIsOpen(false), []);

  const toggleAll = () => setDraft(isAllSelected ? [] : null);

  const toggleTariff = (tariff: string) => {
    const current = draft ?? [...tariffs[isServiceType]];
    const next = current.includes(tariff)
      ? current.filter((t) => t !== tariff)
      : [...current, tariff];
    setDraft(next.length === tariffs[isServiceType].length ? null : next);
  };

  const handleApply = () => {
    if (isNoneSelected) return;
    setSelectedTariffs(draft);
    setIsOpen(false);
  };

  return (
    <>
      <button
        type="button"
        data-trigger="ref.tariff.open"
        className={cls.selector}
        onClick={openSheet}
      >
        <div>
          <div className={cls.selectorLabel}>ТАРИФ</div>
          <div className={cls.selectorValue}>
            {getTariffsLabel(selectedTariffs)}
          </div>
        </div>
        <div className={cls.selectorIcon}>
          <ChevronIcon direction="down" />
        </div>
      </button>

      <Modal isOpen={isOpen} onClose={closeSheet}>
        <div className={cls.sheet}>
          <div className={cls.sheetTitle}>
            Тариф
            <button
              type="button"
              data-trigger="ref.tariff.toggle_all"
              className={cls.sheetAction}
              onClick={toggleAll}
            >
              {isAllSelected ? "Снять все" : "Выбрать все"}
            </button>
          </div>

          {tariffs[isServiceType].map((tariff) => {
            const isChecked = isAllSelected || draft.includes(tariff);
            return (
              <button
                key={tariff}
                type="button"
                data-trigger="ref.tariff.option"
                className={classNames(
                  cls.option,
                  isChecked ? cls.checkedOption : undefined
                )}
                onClick={() => toggleTariff(tariff)}
              >
                <span>{tariff}</span>
                <div className={cls.check}>
                  <CheckIcon />
                </div>
              </button>
            );
          })}

          <div className={cls.sheetFoot}>
            <Button
              trigger="ref.tariff.apply"
              variant="yellow"
              label={
                isNoneSelected ? "Выберите хотя бы один тариф" : "Показать"
              }
              disabled={isNoneSelected}
              onClick={handleApply}
              className={cls.applyButton}
            />
          </div>
        </div>
      </Modal>
    </>
  );
};
